import { render } from "./LootBoxBoxesRow.vue?vue&type=template&id=0b2959d4"
import script from "./LootBoxBoxesRow.vue?vue&type=script&lang=js"
export * from "./LootBoxBoxesRow.vue?vue&type=script&lang=js"

import "./LootBoxBoxesRow.vue?vue&type=style&index=0&id=0b2959d4&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__